import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import queryKey from "../../../../../../enumerations/queryKey";
import { getDepositBet, getFirstDeposit, getNewRegister } from "../service";

export const useGetDownlineNewRegister = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (
      params[key] === null ||
      params[key] === undefined ||
      params[key] === ""
    ) {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.NEW_REGISTER, ..._arrParams],
    ({ pageParam = 1 }) =>
      getNewRegister({ params, page: pageParam }).then((res) => {
        return res.data.data;
      }),
    {
      ...options,
    }
  );
};

export const useGetDownlineFirstDeposit = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (
      params[key] === null ||
      params[key] === undefined ||
      params[key] === ""
    ) {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.FIRST_DEPOSIT, ..._arrParams],
    ({ pageParam = 1 }) =>
      getFirstDeposit({ params, page: pageParam }).then((res) => {
        return res.data.data;
      }),
    {
      ...options,
    }
  );
};

export const useGetDownlineDepositBet = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (
      params[key] === null ||
      params[key] === undefined ||
      params[key] === ""
    ) {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useInfiniteQuery(
    [queryKey.DEPOSIT_BET, ..._arrParams],
    ({ pageParam = 1 }) =>
      getDepositBet({ params, page: pageParam }).then((res) => {
        return res.data.data;
      }),
    {
      ...options,
    }
  );
};
